interface VideoPlayerProps {
  url: string;
  className?: string;
}

const getYouTubeId = (url: string) => {
  const match = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([\w-]+)/i);
  return match ? match[1] : null;
};

const getVimeoId = (url: string) => {
  const match = url.match(/vimeo\.com\/(\d+)/i);
  return match ? match[1] : null;
};

const isDirectVideo = (url: string) => {
  const cleanUrl = url.split('?')[0].toLowerCase();
  return cleanUrl.endsWith('.mp4') || cleanUrl.endsWith('.webm') || cleanUrl.endsWith('.ogg');
};

const VideoPlayer = ({ url, className = 'rounded-2xl overflow-hidden' }: VideoPlayerProps) => {
  if (!url) return null;
  const youTubeId = getYouTubeId(url);
  if (youTubeId) {
    const embedUrl = `https://www.youtube.com/embed/${youTubeId}`;
    return (
      <div className={`relative w-full pt-[56.25%] bg-black ${className}`}>
        <iframe
          src={`${embedUrl}?rel=0`}
          className="absolute inset-0 w-full h-full"
          title="Video"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
    );
  }

  const vimeoId = getVimeoId(url);
  if (vimeoId) {
    const embedUrl = `https://player.vimeo.com/video/${vimeoId}`;
    return (
      <div className={`relative w-full pt-[56.25%] bg-black ${className}`}>
        <iframe
          src={embedUrl}
          className="absolute inset-0 w-full h-full"
          title="Video"
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
    );
  }

  if (isDirectVideo(url)) {
    return (
      <div className={`bg-black ${className}`}>
        <video
          src={url}
          controls
          className="w-full h-full object-contain bg-black"
        />
      </div>
    );
  }

  return (
    <div className={`relative w-full pt-[56.25%] bg-black ${className}`}>
      <iframe
        src={url}
        className="absolute inset-0 w-full h-full"
        title="Video"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
    </div>
  );
};

export default VideoPlayer;

